<template>
  <b-modal
    :title="`Notificar sobre expediente Nº ${file.numero}`"
    v-model="showModal"
    hide-footer
    centered
    no-close-on-backdrop
  >
    <div>
      <h5>
        Selecciona los usuarios a los que quieres notificar
      </h5>
      <div class="wrap-form">
        <v-select
          class="w-100"
          :options="users"
          v-model="usersList"
          name="custom-companies"
          multiple
        >
          <template slot="no-options">
            no hay coincidencias para el criterio de búsqueda
          </template>
        </v-select>
      </div>
      <div class="wrap-commentary">
        <vs-textarea
          data-cy="comment"
          maxlength="1000"
          label="Comentario"
          v-model="commentary"
          counter="1000"
        />
        <span class="text-primary">
          Escribe un comentario para que los destinatarios de la notificación sepan que hacer
        </span>
      </div>
    </div>
    <div class="m-top-20 text-center">
      <vs-button
        v-on:click="sendFileToSubjects()"
        color="primary"
        data-cy="notify-user"
        type="border"
      >
        Notificar usuarios
      </vs-button>
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import { clNotifyOfFile } from '@/febos/servicios/api/dnt.api';

export default {
  name: 'PopUpNotifyFile',
  props: {
    file: {
      type: [Object]
    }
  },
  data() {
    return {
      usersList: [],
      commentary: ''
    };
  },
  watch: {
    file() {
      this.usersList = [];
      this.commentary = '';
    }
  },
  computed: {
    ...mapGetters('Dnts', [
      'commentsEd'
    ]),
    ...mapGetters('Empresas', [
      'empresa',
      'usersCompany'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'notifyFile';
      },
      set() {
        this.closeModal();
      }
    },
    users() {
      return this.usersCompany
        .map((user) => ({ label: user.nombre, id: user.id, value: user.id }));
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Empresas', [
      'getUsersCompany'
    ]),
    ...mapActions('Dnts', [
      'sendDntFile'
    ]),
    async sendFileToSubjects() {
      if (!this.usersList.length) {
        this.$vs.notify({
          title: 'Oops',
          text: 'Por favor selecciona al menos un usuario a notificar',
          color: 'danger',
          time: 4000,
          position: 'top-center'
        });
        return;
      }
      const request = {
        febosId: this.file.febosId,
        body: {
          usuariosIds: this.usersList.map((user) => user.id),
          mensaje: this.commentary
        }
      };
      this.$vs.notify({
        title: 'Genial',
        text: 'Se ha enviado un correo notificando a los usuarios sobre el expediente',
        color: 'success',
        time: 4000,
        position: 'top-center'
      });
      await clNotifyOfFile(request);
      this.usersList = [];
      this.commentary = '';
      this.closeModal();
    }
  }
};
</script>
<style>

.m-top-20 {
  margin-top: 20px;
}

.wrap-option {
  display: flex;
  justify-content: space-around;
}

.wrap-form {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.pill-comment-user {
  width: 90%;
  border: 1px solid #c2f785;
  border-radius: 25px;
  margin-bottom: 10px;
  float: left;
}

.pill-comment-me {
  width: 90%;
  border: 1px solid #3a9eef6b;
  border-radius: 25px;
  margin-bottom: 10px;
  float: right;
}

.wrap-commentary {
  width: 90%;
  margin: 20px auto;
}
</style>
